// extracted by mini-css-extract-plugin
module.exports = {"sectionName":"Blog_sectionName__3Gjmn","link":"Blog_link__2hwrg"};